<div class="green-scroll">
  <figure class='highcharts-figure'>
    <div id="compOneMetricComparisonChart"></div>
  </figure>
</div>